import { Reducer } from 'redux';
import ActionTypes, { TVideoState } from './types';

export const initialState: TVideoState = {
  isFullScreen: true,
  isHideVideo: false,
};

const reducer: Reducer<TVideoState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_VIDEO:
      return { ...state, isFullScreen: action.payload };
    case ActionTypes.SET_VIDEO_HIDE:
      return { ...state, isHideVideo: action.payload };
    default:
      return state;
  }
};

export { reducer as VideoReducer };
